import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/styles.css";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  //const API_URL = process.env.REACT_APP_API_URL; //FOR PRODUCTION

  const handleLogin = async () => {
    setError(""); // Clear previous errors
    try {
      const response = await fetch("https://api.wiczka.eu/api/login/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.token); // Store token
        navigate("/main"); // Redirect to main page
      } else {
        setError("Błędna nazwa użytkownika lub hasło");
      }
    } catch (error) {
      setError("Błąd połączenia z serwerem");
    }
  };

  return (
    <div className="container login-container">
      <h1>Logowanie</h1>
      {error && <p className="error-message">{error}</p>}
      <input
        type="text"
        placeholder="Nazwa użytkownika"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className="input-field"
      />
      <input
        type="password"
        placeholder="Hasło"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="input-field"
      />
      <button className="login-button" onClick={handleLogin}>
        Zaloguj się
      </button>
    </div>
  );
};

export default Login;
